import { Button } from 'components/atoms';
import { useTranslation } from 'react-i18next';
import { PiHouse, PiWarning } from 'react-icons/pi';
import { useNavigate, useRouteError } from 'react-router-dom';

const ErrorPage = () => {
  const navigate = useNavigate();
  const error: any = useRouteError();
  // console.error(error);
  const { t } = useTranslation();

  return (
    <div className="flex flex-col w-full justify-center items-center gap-2 h-full">
      <h2 className="text-[5rem] font-black">{t('error-page.header')}</h2>
      <p className="text-[1rem] mt-[1rem] mb-[2rem] opacity-65">{t('error-page.description')}</p>
      {/* <p className="text-red-600">{error?.statusText || error?.message}</p> */}

      <Button
        onClick={() => {
          navigate('/');
          window.location.reload();
        }}
      >
        <PiHouse />
        {t('error-page.home')}
      </Button>
      <Button
        isClear
        onClick={() => {
          navigate('/support/create');
        }}
      >
        <PiWarning />
        {t('error-page.support')}
      </Button>
    </div>
  );
};

export default ErrorPage;
